/* INAYAH: Newsletter popup -> Klaviyo subscription bridge.
 *
 * The theme newsletter popup posts to Shopify's native /contact customer form
 * (email marketing consent on the Shopify customer, synced to Klaviyo by the
 * Shopify integration). That path is left untouched.
 *
 * This script additionally mirrors the submission to Klaviyo's public client
 * API so that (a) the email lands on the Email List instantly and (b) an
 * optional phone number is subscribed with SMS marketing consent, which
 * triggers the live "SMS Welcome Series with Discount" flow.
 *
 * The fetch calls use keepalive so they survive the native form navigation.
 * Failures are swallowed: the Shopify signup must never break because the
 * Klaviyo call was blocked (ad blockers, network).
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/?company_id=';
  var REVISION = '2024-10-15';

  function subscribe(company, listId, profileAttributes, source) {
    try {
      fetch(ENDPOINT + encodeURIComponent(company), {
        method: 'POST',
        keepalive: true,
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: REVISION,
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: source,
              profile: {
                data: {
                  type: 'profile',
                  attributes: profileAttributes,
                },
              },
            },
            relationships: {
              list: { data: { type: 'list', id: listId } },
            },
          },
        }),
      }).catch(function () {});
    } catch (e) {
      /* never block the native signup */
    }
  }

  function normalizePhone(countryCode, raw) {
    var digits = (raw || '').replace(/\D/g, '').replace(/^0+/, '');
    if (!digits) return { empty: true };
    // National numbers are 7-12 digits once the trunk zero is stripped.
    if (digits.length < 7 || digits.length > 12) return { invalid: true };
    return { phone: countryCode + digits };
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[data-klaviyo-subscribe]')) return;
    var emailInput = form.querySelector('input[name="contact[email]"]');
    var phoneInput = form.querySelector('[data-kl-phone]');
    var ccSelect = form.querySelector('[data-kl-cc]');
    var phoneMessage = form.querySelector('[data-kl-phone-message]');

    var company = form.getAttribute('data-klaviyo-company');
    var emailList = form.getAttribute('data-klaviyo-email-list');
    var smsList = form.getAttribute('data-klaviyo-sms-list');
    if (!company) return;

    var email = emailInput && emailInput.value ? emailInput.value.trim() : '';

    var phone = null;
    if (phoneInput && ccSelect) {
      var result = normalizePhone(ccSelect.value, phoneInput.value);
      var phoneRequired = phoneInput.hasAttribute('required');
      if (result.invalid || (result.empty && phoneRequired)) {
        // Stop the event in the capture phase so the theme's own submit
        // handler (which hides the popup and sets the subscribed cookie)
        // never runs - the popup must stay open to show the error.
        event.preventDefault();
        event.stopPropagation();
        if (phoneMessage) phoneMessage.classList.remove('hidden');
        phoneInput.focus();
        return;
      }
      if (phoneMessage) phoneMessage.classList.add('hidden');
      if (result.phone) phone = result.phone;
    }

    // Client subscription API (revision 2024-10-15): marketing consent is
    // granted for whichever identifiers are present in the profile payload.
    // A `subscriptions` attribute is NOT valid here and 400s the request.
    if (email && emailList) {
      subscribe(company, emailList, { email: email }, 'Newsletter popup');
    }

    if (phone && smsList) {
      // Email is included so the phone merges into the same profile
      // instead of creating a second, phone-only profile.
      var smsProfile = { phone_number: phone };
      if (email) smsProfile.email = email;
      subscribe(company, smsList, smsProfile, 'Newsletter popup');
    }
  }

  // After a successful signup Shopify redirects back with ?customer_posted=true.
  // Hitting the discount share URL sets Shopify's discount cookie so the code
  // is already applied when the new subscriber reaches checkout.
  function autoApplyDiscount() {
    if (window.location.search.indexOf('customer_posted=true') === -1) return;
    var form = document.querySelector('form[data-klaviyo-subscribe][data-kl-discount]');
    var code = form && form.getAttribute('data-kl-discount');
    if (!code) return;
    try {
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
    } catch (e) {
      /* non-critical */
    }
  }

  function init() {
    if (window.__inayahKlSubscribeBound) return;
    window.__inayahKlSubscribeBound = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', autoApplyDiscount);
    } else {
      autoApplyDiscount();
    }
    // Capture phase on document: runs before the theme's own submit handler
    // on the form, so an invalid phone can cancel everything cleanly.
    document.addEventListener('submit', onSubmit, true);
    // Hide the inline error again as soon as the visitor edits the field.
    document.addEventListener('input', function (event) {
      if (!event.target || !event.target.matches || !event.target.matches('[data-kl-phone]')) return;
      var form = event.target.closest('form');
      var msg = form && form.querySelector('[data-kl-phone-message]');
      if (msg) msg.classList.add('hidden');
    }, true);
  }

  init();
})();
